import React from "react";
import { useLanguage } from "@/i18n/LanguageContext";

/** Visual badge for event lifecycle: upcoming | live | completed | archived | cancelled. */
const STYLES = {
  upcoming:  { bg: "#E8F6E5", fg: "#206F18", dot: "#3FA535" },
  live:      { bg: "#FCE7F3", fg: "#A60F6E", dot: "#D81B8C" },
  completed: { bg: "#EFE3F5", fg: "#6B2C8F", dot: "#6B2C8F" },
  archived:  { bg: "#F2E2EC", fg: "#5C4664", dot: "#5C4664" },
  cancelled: { bg: "#FEE2E2", fg: "#B91C1C", dot: "#DC2626" },
};

export default function EventStatusBadge({ status }) {
  const { t } = useLanguage();
  const s = STYLES[status] || STYLES.upcoming;
  const labelKey = {
    upcoming:  "event.statusUpcoming",
    live:      "event.statusLive",
    completed: "event.statusCompleted",
    archived:  "event.statusArchived",
    cancelled: "event.statusCancelled",
  }[status] || "event.statusUpcoming";

  return (
    <span
      data-testid={`event-status-${status}`}
      className="inline-flex items-center gap-1.5 px-2.5 h-6 rounded-full text-[10px] font-bold uppercase tracking-widest"
      style={{ backgroundColor: s.bg, color: s.fg }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: s.dot }} />
      {t(labelKey)}
    </span>
  );
}
